import { SearchFilterMeta } from 'controllers/SearchController/types';

const keepFilterWithSmallerValue = (
    max: number,
    filterMeta?: SearchFilterMeta,
) => {
    return filterMeta
        ? Object.entries(filterMeta).filter(
              ([, filterMetaTotal]) => filterMetaTotal < max,
          )
        : [];
};

export default keepFilterWithSmallerValue;
